export default {
    GBP: 4.95,
    USD: 7.95,
    CAD: 12.5,
    EUR: 12.5,
};
